<div ng-controller="ReadLogController as ctrl" class="modal-view read-log-list">
    <c-read-log-header class="read-log-header-fixed"></c-read-log-header>
    <div class="list-filter list-filter-tools" ng-show="ctrl.showFilter">
        <div centuri-list-filter class="list-filter-elements" config="ctrl.filterConfig" callback="ctrl.filterCallback"></div>
    </div>
    <div id="managed-component"></div>
</div>